<template>
    <div class="t-upload">
        <input ref="upload" type="file" @change="handleChangeFile" hidden>
        <div class="t-upload-content" @click="$refs.upload.click()">
            <i class="el-icon-upload" />
            <slot>
                <span>select file</span>
            </slot>
        </div>
    </div>
</template>

<script>
export default {
    name: "tUpload",
    methods: {
        handleChangeFile(event) {
            const files = event.target.files;
            this.$emit("input", files[0]);
        }
    }
}
</script>

<style lang="less" scoped>
.t-upload {
    display: inline-flex;

    i {
        margin-right: 8px;
    }

    .t-upload-content {
        color: #412682;
        border: 1px solid #412682;
        text-shadow: none;
        display: inline-flex;
        align-items: center;
        justify-content: center;
        height: 40px;
        padding: 0 15px;
        cursor: pointer;
        background: transparent;
        border-radius: 4px;
        line-height: 40px;
    }
}
</style>
